import { Product } from './product';
import { TimedEvent } from './timed-event';
import { Modifier } from './modifier';

export class ProductCategory {
  public id: number;
  public name: string;
  public description: string;
  public products: Array<Product>;
  public image: string;
  public printerTemplates: any;
  public notificationTemplates: any;
  public courseNumber: number;
  public defaultTax: number;
  public defaultTakeawayTax: number;
  public defaultDeliveryTax: number;
  public modifiers: Array<Modifier>;
  public visible: boolean;
  public defaultTaxClassCode: string;
  public timedEvents: Array<TimedEvent>;
  public relativeImage: string;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }
}
